import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

const SEL = "h-10 w-full rounded-md border border-border bg-background px-3";

export const RevertDialog = ({ mv, onClose, onDone }) => {
  const [dest, setDest] = useState("tecnico");
  const [reason, setReason] = useState("");
  const [tech, setTech] = useState("");
  const [loc, setLoc] = useState("");
  const [techs, setTechs] = useState([]);
  const [locs, setLocs] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!mv) return;
    setDest("tecnico"); setReason(""); setTech(""); setLoc("");
    api.get("/inventory/responsibles").then((r) => setTechs(r.data.filter((u) => u.role === "technician"))).catch(() => {});
    api.get("/inventory/locations").then((r) => setLocs(r.data.filter((l) => l.active !== false))).catch(() => {});
  }, [mv]);
  if (!mv) return null;
  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/inventory/movements/${mv.id}/revert`, { destination: dest, reason, responsible_user_id: dest === "tecnico" ? tech || null : null, location_id: dest === "almacen" ? loc || null : null });
      toast.success("Reversión registrada");
      onDone(); onClose();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="revert-dialog">
        <DialogHeader><DialogTitle className="font-display">Revertir consumo / instalación</DialogTitle></DialogHeader>
        <div className="space-y-3 text-sm">
          <p data-testid="revert-item">{mv.item_label} · {mv.quantity} {mv.unit}{mv.serials?.length ? ` · S/N ${mv.serials.join(", ")}` : ""}{mv.folio ? ` · ${mv.folio}` : ""}</p>
          <p className="text-xs text-muted-foreground">El consumo original se conserva. Si es un GPS con SIM, la SIM se revierte con él. La OS no cambia de estado.</p>
          <select className={SEL} value={dest} onChange={(e) => setDest(e.target.value)} data-testid="revert-destination">
            <option value="tecnico">Regresar al inventario del técnico</option>
            <option value="almacen">Regresar al almacén</option>
          </select>
          {dest === "tecnico" ? <select className={SEL} value={tech} onChange={(e) => setTech(e.target.value)} data-testid="revert-technician">
            <option value="">Responsable original</option>
            {techs.map((u) => <option key={u.id} value={u.id}>{u.name}</option>)}
          </select> : <select className={SEL} value={loc} onChange={(e) => setLoc(e.target.value)} data-testid="revert-location">
            <option value="">Ubicación original ({mv.location_path || "—"})</option>
            {locs.map((l) => <option key={l.id} value={l.id}>{l.path || l.name}</option>)}
          </select>}
          <Textarea rows={2} placeholder="Motivo de la reversión (obligatorio)" value={reason} onChange={(e) => setReason(e.target.value)} data-testid="revert-reason" />
          <Button className="w-full" disabled={busy || !reason.trim()} onClick={submit} data-testid="revert-submit">Registrar reversión</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
